import API from "../../../app/api";
export const addToCart = async (payload) => {
  try {
    const response = await API.post(
      `/cart`,
      payload
    );

    return response?.data;
  } catch (error) {
    throw error;
  }
};